<template>
<b-card class="d-flex flex-row mb-3" no-body>
    <div class="d-flex flex-grow-1 min-width-zero">
        <b-card-body class="align-self-center d-flex flex-column flex-md-row justify-content-between min-width-zero align-items-md-center">
            <router-link tag="a" :to="detailPath" class="list-item-heading mb-1 truncate w-40 w-xs-100">{{formatDate(data.date)}}</router-link>
            <p class="mb-1 text-muted text-small w-15 w-xs-100">{{data.heure}}</p>
            <p class="mb-1 text-muted text-small w-20 w-xs-100">{{data.price_gived}}DH</p>
            <!-- <div class="w-15 w-xs-100">
              <switches
                v-model="status"
                @click.native="changedStatus($event)"
                theme="custom"
                color="secondary-inverse"
                class="display-table-cell"
              ></switches>
            </div> -->
            <div class="w-25 w-xs-100">
                <div class="custom-control custom-checkbox pl-1 align-self-center text-right pr-4">
                    
                    <b-button v-if="!status" @click.stop="changedStatus()" class="mb-1 mr-1" variant="success"><i class="simple-icon-check"></i></b-button>
                    <!-- <b-button @click.stop="editItem()" class="mb-1" variant="primary"><i class="iconsminds-pen"></i></b-button> -->
                    <b-button @click.stop="editItem()" class="mb-1" variant="primary"><i class="iconsminds-pen"></i></b-button>
                    <b-button @click.stop="deleteItem()" class="mb-1 ml-1" variant="danger"><i class="simple-icon-trash"></i></b-button>
                </div> 
                <!-- <b-badge pill :variant="data.statusColor">{{ data.status}}</b-badge> -->
            </div>
        </b-card-body>
    </div>
</b-card>
</template>
<script>
import Switches from 'vue-switches'
import { apiUrl } from "@/constants/config";
import {fr} from "moment/locale/fr"

import moment from 'moment'
moment.locale('fr',fr)
export default {
  props: ['data', 'detailPath'],
  data(){
    return {
      status:true
    }
  },
  watch:{
    data:{
      deep:true,
      handler(){
        console.log("changed data")
        this.status = this.data.isconfirmed==1?true:false
      }
    },
    status(){
      
    }
  },
  mounted(){
    this.status = this.data.isconfirmed?true:false
  },
  methods:{
    changedStatus(event){
      // console.log("event",event)
      // return
      let obj = {
        date: this.data.date,
        heure: this.data.heure,
        isconfirmed: 1,
        price_gived: this.data.price_gived
      };
      let currentEndpoint = `${apiUrl}/rdvs/id/${this.data.id}`;
      this.sendRequest("put", currentEndpoint, obj)
      .then(res => {
        console.log("reees ediiit status", res);
        // this.data = {...res.data}
        this.$emit("changeData",res.data)
        // this.$forceUpdate()
      })
      .catch(err => {
        // this.isLoad = true;
        console.log("iam the error", err);
      });
    },
    formatDate(date){
      return moment(date).format('dddd')+' '+moment(date).format('DD/MM/yyyy')
    },
    editItem(){
      this.$emit("edit",true)
    },
    deleteItem(){
      this.$emit("delete",true)
    }
  },
  components:{
    Switches
  }
}
</script>
